import { Component, ElementRef, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { SMSservice } from '../../../../core/services/sms.service';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../../environments/environment';
import { PatientEngagementService } from '../../services/patient-engagement.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrl: './subscription.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class SubscriptionComponent implements OnInit {
  elinkParams:any;
  elinkData:any;
  textStr:string="onLoad";
  subScriptionStatus!:string;
  isSubscribed!: boolean;
  isSubStatus!: boolean;
  message!: string;
  action!: string;
  isFrmElink: boolean = false;
  pharmacyLogo: any;
  pharmacyInfo: any;
  constructor(
    private smsService:SMSservice,
    private auth : AuthService,
    private _patientEngagementService :PatientEngagementService
  ) {  }
  
  ngOnInit(): void {
    this.elinkData = localStorage.getItem("eLinkData")!== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    this.isSubscribed = (this.elinkData?.ElinkType === 'Subscription') ? true : false;
    this.getUserDetails();
    this.toggleSubscription(this.textStr);
    this.getPharmacyLogo();
  }
  async toggleSubscription(type:any): Promise<void> {
      if(type === 'click') {
        this.isSubStatus = (this.isSubscribed === true) ? false : true;
        this.isSubscribed = !this.isSubscribed;
      } else if(type === 'onLoad'){
        this.isSubStatus = (this.elinkData?.ElinkType === 'Subscription') ? true : false;
        this.updateMessages();
      }
      const SubPayload = {
        "pharmacyNpi": this.elinkParams?.npi,
        "patientId": this.elinkData?.EntityId,
        "status": this.isSubStatus
      }
      try {
          await this.smsService.postUpdateSubscription(SubPayload).then(data => {
            if(data){
              this.updateMessages();
            }
          });
      } catch (error) {
          console.log(error);
      }
  }

  getUserDetails(){
    if(this.elinkData && this.elinkData?.EntityId){
      let patientNo = {
        "patientNo": this.elinkData?.EntityId
      }
      this._patientEngagementService.postUserDetails(patientNo).subscribe(result =>{
        if(result){
          this.isFrmElink = result?.identifier ? true : false;
        }
      }); 
    }
  }

  async getPharmacyLogo() {
    const phInfo = {
      "pharmacyNpi": this.elinkParams?.npi,
      "patientId": this.elinkData?.EntityId,
      "isPharmacyLogoRequired": true
    };
    try {
      const resp = await this._patientEngagementService.getPharmacyLogo(phInfo).toPromise();
      if (resp) {
        try {
          const exists = await this._patientEngagementService.checkImageExists(resp.pharmacyLogo);
          if (exists) {
            this.pharmacyLogo = resp.pharmacyLogo;
          }
          this.pharmacyInfo = resp;
        } catch (error) {
          console.error('Error checking image existence:', error);
        }
      }
    } catch (error) {
      console.error('Error posting pharmacy info:', error);
    }
  }
  async updateMessages() {
    if (this.isSubscribed) {
      this.message = 'Your subscription to alerts is activated.'; 
      this.action = 'unsubscribe';
    } else {
      this.message = 'Your subscription to alerts is deactivated.';
      this.action = 'subscribe';
    }
  }
  signUpWithRedirect(): void {
    localStorage.setItem('IsGuestUser', JSON.stringify(false));
    const pharmacyLogoDetails = {
      pharmacyLogo : this.pharmacyLogo ? this.pharmacyLogo : null,
      pharmacyInfo : this.pharmacyInfo ? this.pharmacyInfo : null
    };
    this.auth.loginWithRedirect({
      authorizationParams: {
        redirect_uri: environment.AUTH0_CALL_BACK,
        screen_hint: "signup",
        state: JSON.stringify({ returnUrl: window.location.href }),
        isFrmElink: true,
        pharmacyLogoDetails: JSON.stringify(pharmacyLogoDetails),
      }
    });
  }
  loginWithRedirect(): void {
    localStorage.setItem('IsGuestUser', JSON.stringify(false));
    this.auth.loginWithRedirect({
      authorizationParams: {
        redirect_uri: environment.AUTH0_CALL_BACK,
        screen_hint: "login",
        state: JSON.stringify({ returnUrl: window.location.href }),
        isFrmElink: false
      }
    });
  }
}
